import Vue from "vue";
import Vuex from "vuex";

import api from "./api";

import catalogue from "./_mock/catalogue.json";

import tat_lang from "./_mock/lang/tat.json";
import ru_lang from "./_mock/lang/ru.json";

import {RoleEnums} from "./const/index.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isAuthorized: false,
    accessToken: localStorage.access || "",
    userData: null,
    catalogue: catalogue,
    lang: "RU",
    translation: ru_lang,
    managerShifts: null,
    regionAreas: null
    // lang: localStorage.lang === "TAT" ? "TAT" : "RU",
    // translation: localStorage.lang === "TAT" ? tat_lang : ru_lang
  },
  getters: {
    getShiftById: state => id => {
      return state.shiftsData.find(shift => shift.id === id);
    },
    shiftSeasons: state => () => {
      const seasons = {};
      state.catalogue.campSeasons.map(el => {
        seasons[el.value] = el.text;
        return el;
      });
      return seasons;
    },
    requestOrders: state => () => {
      const orders = {};
      state.catalogue.orderStatuses.map(el => {
        orders[el.server_value] = el;
        return el;
      });
      return orders;
    }
  },
  mutations: {
    setTranslationData(state, data) {
      window.localStorage.lang = data;
      if (data === "RU") {
        state.translation = ru_lang;
        state.lang = "RU";
      } else {
        state.translation = tat_lang;
        state.lang = "TAT";
      }
    },
    setToken(state, data) {
      state.isAuthorized = true;
      state.accessToken = data.access_token;
      localStorage.access = data.access_token;
    },
    removeToken(state) {
      state.isAuthorized = false;
      state.accessToken = "";
      state.userData = null;
      localStorage.access = "";
    },
    setUser(state, data) {
      state.isAuthorized = true;
      state.userData = data;
    },
    updateUser(state, data) {
      state.userData = data;
    },
    setShifts(state, data) {
      if (state.userData && state.userData.role === RoleEnums.DIRECTOR) {
        state.managerShifts = data.results;
      }
    },
    setRegionAreas(state, data) {
      state.regionAreas = data;
    }
  },
  actions: {
    // dadata
    getSuggetionDaData(store, {data, url}) {
      return api.postMethodDaData(store, {
        url: `https://dadata.ru/api/v2/${url}`,
        data: data
      });
    },
    // default sourse get
    getSource(store, data) {
      if (!data.url) {
        return;
      }
      return api.getMethod(store, {
        url: data.url
      });
    },
    //get region areas list
    getRegionAreas(store) {
      return api.getMethod(store, {
        url: "/api/users/areas/",
        mutationType: "setRegionAreas"
      });
    },
    // authorization
    auth(store, data) {
      return api.authMethod(store, {
        url: "/api/users/login/",
        data: data.userCredentials,
        xAuthHash: data.xAuthHash,
        mutationType: "setToken"
      });
    },
    resendAuthLink(store, data) {
      return api.authMethod(store, {
        url: "/api/users/resend-confirmation-email/",
        data: data.data,
        xAuthHash: data.xAuthHash
      });
    },
    // registration
    reg(store, data) {
      return api.authMethod(store, {
        url: "/api/users/uregister/",
        data: data.userCredentials,
        xAuthHash: data.xAuthHash
      });
    },
    confirmRegistration(store, data) {
      return api.authMethod(store, {
        url: "/api/users/confirm-email/",
        data: data.data,
        xAuthHash: data.xAuthHash,
        mutationType: "setToken"
      });
    },
    // password
    resetPassword(store, data) {
      return api.authMethod(store, {
        url: "/api/users/reset-password/",
        data: data.data,
        xAuthHash: data.xAuthHash
      });
    },
    changePassword(store, data) {
      const _data = data && data.data ? data.data : {};
      const _params = data && data.params ? data.params : {};
      return api.putMethod(store, {
        url: "/api/users/change-password/",
        data: _data,
        params: _params
      });
    },
    // emails
    changeEmail(store, data) {
      return api.postMethod(store, {
        url: "/api/users/change-email/",
        data: data
      });
    },
    cancelChangeEmail(store) {
      return api.deleteMethod(store, {
        url: "/api/users/change-email/"
      });
    },
    confirmChangeEmail(store, data) {
      return api.postMethod(store, {
        url: "/api/users/confirm-changing-email/",
        data: data
      });
    },
    // profile
    getUser(store) {
      return api.getMethod(store, {
        url: "/api/users/profile/",
        mutationType: "setUser"
      });
    },
    updateUserProfile(store, data) {
      return api.putMethod(store, {
        url: "/api/users/profile/",
        mutationType: "updateUser",
        data: data
      });
    },
    // child
    getChilds(store) {
      return api.getMethod(store, {
        url: "/api/users/childs/"
      });
    },
    addChild(store, data) {
      return api.postMethod(store, {
        url: "/api/users/childs/",
        data: data
      });
    },
    updateChild(store, {data, id}) {
      return api.putMethod(store, {
        url: `/api/users/childs/${id}/`,
        data: data
      });
    },
    deleteChild(store, id) {
      return api.deleteMethod(store, {
        url: `/api/users/childs/${id}/`
      });
    },
    // camps
    getCamps(store, data) {
      const _params = data && data.params ? data.params : {};
      return api.getMethod(store, {
        url: "/api/camps/",
        params: _params
      });
    },
    getCampsMap(store, data) {
      const _params = data && data.params ? data.params : {};
      return api.getMethod(store, {
        url: "/api/camps/data-for-map/",
        params: _params
      });
    },
    getCamp(store, id) {
      return api.getMethod(store, {
        url: `/api/camps/${id}/`
      });
    },
    updateCamp(store, data) {
      return api.patchMethod(store, {
        url: `/api/camps/${data.id}/`,
        data: data.data
      });
    },
    deleteCamp(store, id) {
      return api.deleteMethod(store, {
        url: `/api/camps/${id}/`
      });
    },
    // campshifts
    getShifts(store, data) {
      const params = data && data.params ? data.params : {};
      return api.getMethod(store, {
        url: "/api/campshifts/",
        params: params,
        mutationType: "setShifts"
      });
    },
    getShiftsMap(store, data) {
      const _params = data && data.params ? data.params : {};
      return api.getMethod(store, {
        url: "/api/campshifts/data-for-map/",
        params: _params
      });
    },
    getShift(store, id) {
      return api.getMethod(store, {
        url: `/api/campshifts/${id}/`
      });
    },
    // attachments
    addAttachments(store, data) {
      const _data = data || {};
      return api.postMethod(store, {
        url: "/api/attachments/upload/",
        data: _data
      });
    },
    // awards
    addAward(store, data) {
      const _data = data || {};
      return api.postMethod(store, {
        url: "/api/attachments/child-awards/",
        data: _data
      });
    },
    updateAward(store, data) {
      return api.putMethod(store, {
        url: `/api/attachments/child-awards/${data.id}/`,
        data: data
      });
    },
    // orders
    createOrders(store, data) {
      const _data = data || {};
      return api.postMethod(store, {
        url: "/api/orders/",
        data: _data
      });
    },
    getOrders(store, params) {
      const _params = params || {};
      return api.getMethod(store, {
        url: "/api/orders/",
        params: _params
      });
    },
    getOrder(store, id) {
      return api.getMethod(store, {
        url: `/api/orders/${id}`
      });
    },
    deleteOrder(store, id) {
      return api.deleteMethod(store, {
        url: `/api/orders/${id}/`
      });
    },
    changeOrderStatus(store, {data, id}) {
      const _data = data || {};
      return api.postMethod(store, {
        url: `/api/orders/${id}/change_status/`,
        data: _data
      });
    },
    deleteOrderAwards(store, {orderId, awardId}) {
      return api.deleteMethod(store, {
        url: `/api/orders/${orderId}/delete_award/${awardId}/`
      });
    },
    // notifications
    getNotifications(store) {
      return api.getMethod(store, {
        url: "/api/notifications/notifications-list/"
      });
    },
    //contact-forms
    sendContactForm(store, data) {
      return api.postMethodDaData(store, {
        url: "/api/mailing/contact-form/",
        data: data
      });
    },

    //camp group admin
    getCampManagers(store) {
      //val = 0 - Директора не прикрепленные к лагерю
      //val = 1 - Все директора
      return api.getMethod(store, {
        url: "/api/users/staff/?camp=1"
      });
    },
    //create camp admin
    createCamp(store, data) {
      const _data = data || {};
      return api.postMethod(store, {
        url: "/api/camps/",
        data: _data
      });
    },
    getCampGroupManagers(store) {
      return api.getMethod(store, {
        url: "/api/users/staff/?staff=campgroup"
      });
    },
    updateCampStaff(store, {data, id}) {
      const _data = data || {};
      return api.patchMethod(store, {
        url: `/api/users/staff/${id}/?camp=1`,
        data: _data
      });
    },
    deleteCampStaff(store, id) {
      return api.deleteMethod(store, {
        url: `/api/users/staff/${id}/`
      });
    },
    getCampgroups(store) {
      return api.getMethod(store, {
        url: "/api/campgroups/"
      });
    },
    getStaffAccount(store, id) {
      return api.getMethod(store, {
        url: `/api/users/staff/${id}`
      });
    },
    createStaffAccount(store, data) {
      const _data = data || {};
      return api.postMethod(store, {
        url: "/api/users/staff/",
        data: _data
      });
    },
    updateStaffAccount(store, {data, id}) {
      const _data = data || {};
      return api.patchMethod(store, {
        url: `/api/users/staff/${id}/`,
        data: _data
      });
    },

    createShift(store, data) {
      const _data = data || {};
      return api.postMethod(store, {
        url: "/api/campshifts/",
        data: _data
      });
    },
    deleteShift(store, id) {
      return api.deleteMethod(store, {
        url: `/api/campshifts/${id}/`
      });
    },
    updateShift(store, {data, id}) {
      const _data = data || {};
      return api.patchMethod(store, {
        url: `/api/campshifts/${id}/`,
        data: _data
      });
    },
    getHouses(store, data) {
      const _params = data && data.params ? data.params : {};
      return api.getMethod(store, {
        url: "/api/houses/",
        params: _params
      });
    },
    getQuotasHouses(store, params) {
      const _params = params || {};
      return api.getMethod(store, {
        url: "/api/quotashouses/",
        params: _params
      });
    },
    createQuotasHouse(store, data) {
      const _data = data || {};
      return api.postMethod(store, {
        url: "/api/quotashouses/",
        data: _data
      });
    },
    updateQuotasHouse(store, {data, id}) {
      const _data = data || {};
      return api.patchMethod(store, {
        url: `/api/quotashouses/${id}/`,
        data: _data
      });
    },
    deleteQuotasHouse(store, id) {
      return api.deleteMethod(store, {
        url: `/api/quotashouses/${id}/`
      });
    },
    getQuotas(store, params) {
      const _params = params || {};
      return api.getMethod(store, {
        url: "/api/quotas/",
        params: _params
      });
    },
    getQuota(store, id) {
      return api.getMethod(store, {
        url: `/api/quotas/${id}`
      });
    },
    updateQuota(store, {data, id}) {
      const _data = data || {};
      return api.patchMethod(store, {
        url: `/api/quotas/${id}/`,
        data: _data
      });
    },
    createQuota(store, data) {
      const _data = data || {};
      return api.postMethod(store, {
        url: "/api/quotas/",
        data: _data
      });
    },
    deleteQuota(store, id) {
      return api.deleteMethod(store, {
        url: `/api/quotas/${id}/`
      });
    },
    getPaymentUrl(store, id) {
      return api.getMethod(store, {
        url: `/api/orders/${id}/get-payment-url/`

      });
    },
    createCampHouse(store, data) {
      const _data = data || {};
      return api.postMethod(store, {
        url: "/api/houses/",
        data: _data
      });
    },
    updateCampHouse(store, {data, id}) {
      const _data = data || {};
      return api.patchMethod(store, {
        url: `/api/houses/${id}/`,
        data: _data
      });
    },
    deleteCampHouse(store, id) {
      return api.deleteMethod(store, {
        url: `/api/houses/${id}/`
      });
    },
    //off order
    createOffOrder(store, data) {
      const _data = data || {};
      return api.postMethod(store, {
        url: "/api/orders/offorder/",
        data: _data
      });
    }
  }
});
